module.exports = __webpack_public_path__ + "7a2178979835ea9f0a6986f8ab5b820b.svg";